<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24.137"
    height="26.535"
    viewBox="0 0 24.137 26.535"
  >
    <g
      id="Group_890"
      data-name="Group 890"
      transform="translate(-169.328 -275.777) rotate(-21)"
    >
      <path
        id="Subtraction_7"
        data-name="Subtraction 7"
        d="M21729.488,18114.355h-11.525a3,3,0,0,1-3-3v-15.7a3,3,0,0,1,3-3h11.525a3,3,0,0,1,3,3v15.7A3,3,0,0,1,21729.488,18114.355Zm-11.607-6.93v3h11.684v-3h-11.684Zm0-5.422v3h11.684v-3h-11.684Zm0-5.426v3h11.684v-3h-11.684Z"
        transform="translate(-21657.961 -17768.654)"
        fill="#bbb"
      />
    </g>
  </svg>
</template>
<script setup lang="ts">
import IconProps from '@/assets/ts/interfaces/IconProps'

withDefaults( defineProps<IconProps>(), {} )
</script>